import React from "react";
import Footer from "../core-components/Footer";
import { PageSkeleton, PageStatus, useDelayedPlaceholder } from "../page-experience/PageExperience";

// Shared presentation; the access decision remains with the route gate.
export default function AccessStatusPage({ error, onRetry, showFooter = false }) {
  const visible = useDelayedPlaceholder();
  return <>
    <div className="PageExperience" aria-busy={!error}>
      {error ? <PageStatus error title="We couldn't confirm your access" onRetry={onRetry}
        message={error.code === "access/team-mismatch"
          ? "Select the team for this page in the sidebar, then try again."
          : "Please try again. Your account or team access has not been changed."} />
        : <PageSkeleton visible={visible} label="Checking access…" />}
    </div>
    {showFooter && <Footer />}
  </>;
}
